import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {MatTreeModule} from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

import {EditLabelModule} from '@components/edit-label/edit-label.module';

import { ItemTreeComponent } from './item-tree.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatInputModule} from '@angular/material/input';

@NgModule({
  declarations: [ItemTreeComponent ],
  exports: [ ItemTreeComponent ],
  imports: [
    EditLabelModule,
    CommonModule,
    FormsModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    TranslateModule,
    MatInputModule
  ]
})
export class ItemTreeModule { }
